import { api } from './client';
import type { LostClaim, LostClaimWithImages, LostClaimImage, CreateClaimInput, ClaimStatus } from '../types';

export const lostClaimsApi = {
  list: (params?: { status?: ClaimStatus }) => {
    const qs = new URLSearchParams();
    if (params?.status) qs.set('status', params.status);
    const query = qs.toString();
    return api.get<LostClaim[]>(`/lost-claims${query ? `?${query}` : ''}`);
  },

  get: (id: number) => api.get<LostClaimWithImages>(`/lost-claims/${id}`),

  create: (data: CreateClaimInput) => api.post<LostClaim & { matches_found: number }>('/lost-claims', data),

  update: (
    id: number,
    data: Partial<CreateClaimInput> & { status?: ClaimStatus; matched_item_id?: number | null }
  ) => api.patch<LostClaim>(`/lost-claims/${id}`, data),

  unmatch: (id: number) => api.post<void>(`/lost-claims/${id}/unmatch`, {}),

  delete: (id: number) => api.delete<{ success: boolean }>(`/lost-claims/${id}`),

  addImage: (claimId: number, ziplineUrl: string, ziplineId?: string) =>
    api.post<LostClaimImage>(`/lost-claims/${claimId}/images`, { zipline_url: ziplineUrl, zipline_id: ziplineId }),

  deleteImage: (claimId: number, imageId: number) =>
    api.delete<{ success: boolean }>(`/lost-claims/${claimId}/images/${imageId}`),
};
